export const EXPORT_EMAIL_DRAWER_PT_BR = {
	title: "Exportações",
	description:
		"Informe o seu e-mail para receber a planilha. Enviaremos a planilha em alguns minutos e ela também ficará disponível aqui por 7 dias.",
	form: {
		label: "E-mail",
		placeholder: "Digite aqui seu e-mail",
		required: "E-mail é obrigatório",
		emailInvalid: "E-mail inválido",
		submit: "Exportar planilha",
	},
};

export type ExportEmailDrawerTranslations = typeof EXPORT_EMAIL_DRAWER_PT_BR;
